import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api";
import { Status } from "../../common/constants";
import { deviceLogUrl } from "../../config";
import { RootState } from "../../store";
import {
  IDeviceLogsPayload,
  IDeviceLogsState,
  IDeviceLogsResponse,
} from "../../common/types/devicesTypes";

const DEVICE_LOG = "deviceLog";

const initialState: IDeviceLogsState = {
  status: Status.IDLE,
  error: null,
  msg: null,
  link: null,
};

export const deviceLog = createAsyncThunk(
  DEVICE_LOG,
  async (payload: IDeviceLogsPayload, { rejectWithValue }) => {
    try {
      const response = await api.get(
        deviceLogUrl + `?deviceId=${payload.deviceId}`
      );
      const deviceLogResponse: IDeviceLogsResponse = response.data;
      return deviceLogResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const deviceLogSlice = createSlice({
  name: DEVICE_LOG,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deviceLog.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(deviceLog.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
        state.link = action.payload.link;
      })
      .addCase(deviceLog.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Error occurred while fetching logs";
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.deviceLogs;

export default deviceLogSlice.reducer;
